
import { Card } from "ant-design-vue"
import "./src/card.less"
const { ...other } = Card
const YwCard = {
	...other,
	name:"YwCard"
};

YwCard.install = function (Vue) {
	Vue.component(YwCard.name, Card);
};

export default YwCard;
